import React from "react";
import { Link } from "react-router-dom";

const Career = () => {
  const jobOpenings = [
    {
      title: "Frontend Developer",
      location: "Remote",
      type: "Full-Time",
      description:
        "Looking for a React.js developer with experience in Tailwind CSS and responsive design.",
    },
    {
      title: "Digital Marketing Executive",
      location: "Mumbai, India",
      type: "Full-Time",
      description:
        "Seeking a creative marketing professional skilled in SEO, SEM, and social media advertising.",
    },
  ];

  const perks = [
    {
      title: "Remote Friendly",
      desc: "Work from anywhere with a flexible schedule.",
    },
    {
      title: "Career Growth",
      desc: "Opportunities to advance and upskill constantly.",
    },
    {
      title: "Inclusive Culture",
      desc: "Respectful, diverse, and collaborative team.",
    },
  ];

  return (
    <div className="bg-white text-gray-800 font-sans">
      {/* Header */}
      <div className="text-center py-16 px-4 border-b bg-gray-50">
        <h1 className="text-4xl sm:text-5xl font-extrabold text-[#2B3DA8] mb-4">
          Careers at Foict
        </h1>
        <p className="max-w-2xl mx-auto text-gray-600 text-lg">
          Be a part of a growing team that’s redefining the future of job search and education.
        </p>
      </div>

      {/* Who We Are */}
      <section className="max-w-6xl mx-auto py-16 px-6">
        <h2 className="text-3xl font-semibold text-[#2B3DA8] mb-6">Who We Are</h2>
        <p className="text-gray-700 leading-relaxed text-lg">
          At Foict, we’re driven by the mission to connect learners with career opportunities through
          innovative, tech-driven platforms. Our team values curiosity, creativity, and collaboration.
        </p>
      </section>

      {/* Why Work With Us */}
      <section className="bg-gray-100 py-16 px-6">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-semibold text-[#2B3DA8] mb-10 text-center">
            Why Join Foict
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            {perks.map((item, index) => (
              <div
                key={index}
                className="bg-white shadow-md border rounded-lg p-6 text-center hover:shadow-lg transition"
              >
                <h3 className="text-xl font-semibold text-[#2B3DA8] mb-2">
                  {item.title}
                </h3>
                <p className="text-gray-600 text-sm">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Open Positions */}
      <section className="max-w-6xl mx-auto py-16 px-6">
        <h2 className="text-3xl font-semibold text-[#2B3DA8] mb-8 text-center">
          Open Positions
        </h2>
        <div className="grid md:grid-cols-2 gap-8">
          {jobOpenings.map((job, index) => (
            <div
              key={index}
              className="border border-gray-200 rounded-lg p-6 shadow-sm hover:shadow-md transition"
            >
              <h3 className="text-xl font-bold text-[#2B3DA8] mb-2">
                {job.title}
              </h3>
              <p className="text-sm text-gray-500 mb-1">
                {job.location} | {job.type}
              </p>
              <p className="text-gray-700 mb-4">{job.description}</p>
              <Link
                to="/career-form"
                className="inline-block bg-black text-white text-sm px-5 py-2 rounded hover:bg-[#1e2c77] transition"
              >
                Apply Now
              </Link>
            </div>
          ))}
        </div>
      </section>

      {/* Can't Find Role Section */}
      <section className="bg-white border-t py-16 px-6 text-center">
        <h2 className="text-2xl sm:text-3xl font-semibold text-[#2B3DA8] mb-4">
          Can’t Find the Role You’re Looking For?
        </h2>
        <p className="text-gray-600 mb-6 max-w-xl mx-auto">
          We’re always open to new talent. Submit your resume and we’ll contact you when a matching
          opportunity becomes available.
        </p>
        <Link
          to="/career-form"
          className="bg-black text-white px-6 py-3 text-sm rounded hover:bg-[#1e2c77] transition"
        >
          Submit Resume
        </Link>
      </section>
    </div>
  );
};

export default Career;
